import React, { useState } from "react";
import "./HomeOurGlobalPresence.css";
import "bootstrap/dist/css/bootstrap.min.css";

const HomeOurGlobalPresence = ({ currentLanguage = "en" }) => {
  const isFrench = currentLanguage === "fr";

  // ================= ENGLISH DATA =================
  const dataEN = {
    heading: "OUR GLOBAL PRESENCE",
    locations: [
      {
        flag: "/assets/images/map/burkina.png",
        title: "Ouagadougou",
        country: "Burkina Faso",
        x: 42,
        y: 49,
      },
      {
        flag: "/assets/images/map/ivory.png",
        title: "Abidjan",
        country: "Côte d'Ivoire",
        x: 39,
        y: 54,
      },
    ],
  };

  // ================= FRENCH DATA =================
  const dataFR = {
    heading: "NOTRE PRÉSENCE MONDIALE",
    locations: [
      {
        flag: "/assets/images/map/burkina.png",
        title: "Ouagadougou",
        country: "Burkina Faso",
        x: 42,
        y: 49,
      },
      {
        flag: "/assets/images/map/ivory.png",
        title: "Abidjan",
        country: "Côte d’Ivoire",
        x: 39,
        y: 54,
      },
    ],
  };

  // ================= SELECT DATA =================
  const data = isFrench ? dataFR : dataEN;
  const { heading, locations } = data;

  const [active, setActive] = useState(locations[0]);

  return (
    <section className="section home-global-wrapper">

      <h2 className="text-center mb-5 home-global-wrapper-head">
        {heading}
      </h2>

      <div className="row align-items-center mobilemaplocationBox">

        {/* LEFT MAP */}
        <div className="leftmapbox mb-4 mb-lg-0 position-relative">
          <img
            src="/assets/images/map/global-map.png"
            alt="Global Map"
            className="global-map-img"
          />

          {/* MOVING MAP LABEL */}
          <div
            className="map-marker"
            style={{
              top: `${active.y}%`,
              left: `${active.x}%`,
            }}
          >
            <div className="marker-card">
              <div>
                <img src={active.flag} className="marker-flag" alt="" />
              </div>
              <div>
                <h6 className="m-0">{active.title}</h6>
                <p className="m-0">{active.country}</p>
              </div>
            </div>
            <div className="marker-arrow"></div>
          </div>
        </div>

        {/* RIGHT LIST */}
        <div className="rightlocationbox">
          <div className="timeline-line"></div>

          {/* FIXED DOTS */}
          <div className="timeline-fixed-dot top-dot"></div>
          <div className="timeline-fixed-dot bottom-dot"></div>

          {locations.map((item, index) => (
            <div
              key={index}
              className="d-flex align-items-start gap-3 location-box"
              onMouseEnter={() => setActive(item)}
            >
              <div className="location-card">
                <div>
                  <img src={item.flag} className="flag-icon" alt="" />
                </div>
                <div>
                  <h6>{item.title}</h6>
                  <p>{item.country}</p>
                </div>
              </div>

              <div className="timeline-dot">
                <img
                  src="/assets/images/locationIcon.png"
                  alt="location"
                />
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default HomeOurGlobalPresence;
